import React, { useState } from "react";
import HeroSection from "components/common/sections/HeroSection";
import TryDemoSection from "components/common/sections/TryDemoSection";
import PricingSection from "components/common/sections/PricingSection";

const Pricing = () => {
  const [showSteps, setShowSteps] = useState(false);

  return (
    <>
      {/* Hero section */}
      <HeroSection showVideo={false} setShowSteps={setShowSteps} />

      {/* Pricing section */}
      <PricingSection />

      {/* Try CTA section */}
      <TryDemoSection />
    </>
  );
};

export default Pricing;
